import { localNum } from "@faire/web--source/common/localization/localize";
import { isNotUndefined } from "@faire/web--source/common/typescriptUtils";
function bpsToPercent(value) {
    return isNotUndefined(value) ? Math.floor(value / 100) : undefined;
}
var percentToString = function(percentage, strictLocalize) {
    return strictLocalize({
        id: "GxKNMt",
        defaultMessage: [
            {
                type: 1,
                value: "percentageNumber"
            },
            {
                type: 0,
                value: "%"
            }
        ]
    }, {
        percentageNumber: Math.floor(percentage)
    });
};
export var bpsToPercentString = function(bps, strictLocalize, digit) {
    if (isNotUndefined(digit)) {
        return localNum(bps / 10000, {
            style: "percent",
            minimumFractionDigits: digit,
            maximumFractionDigits: digit
        });
    }
    return percentToString(bpsToPercent(bps), strictLocalize);
};
